import React from 'react';
import { FormControl, InputLabel, Select, MenuItem } from '@mui/material';
import { cn } from '@/lib/utils';

interface SelectOption {
  value: string;
  label: string;
}

interface MaterialSelectProps {
  label: string;
  value: string;
  onChange: (value: string) => void;
  options: SelectOption[];
  placeholder?: string;
  className?: string;
  disabled?: boolean;
  error?: boolean;
  fullWidth?: boolean;
}

export const MaterialSelect: React.FC<MaterialSelectProps> = ({
  label,
  value,
  onChange,
  options,
  placeholder: _placeholder = "Select an option...",
  className,
  disabled = false,
  error = false,
  fullWidth = true,
  ...props
}) => {
  const handleChange = (event: any) => {
    onChange(event.target.value);
  };

  return (
    <FormControl 
      fullWidth={fullWidth} 
      disabled={disabled} 
      error={error}
      className={cn(className)}
      {...props}
    >
      <InputLabel 
        sx={{ 
          color: 'rgb(75, 85, 99)',
          '&.Mui-focused': { color: 'rgb(59, 130, 246)' },
          '&.Mui-error': { color: 'rgb(239, 68, 68)' }
        }}
      >
        {label}
      </InputLabel>
      <Select
        value={value}
        label={label}
        onChange={handleChange}
        sx={{
          backgroundColor: 'white',
          color: 'rgb(17, 24, 39)',
          '& .MuiOutlinedInput-notchedOutline': {
            borderColor: 'rgb(229, 231, 235)',
          },
          '&:hover .MuiOutlinedInput-notchedOutline': {
            borderColor: 'rgb(209, 213, 219)',
          },
          '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
            borderColor: 'rgb(59, 130, 246)',
          },
          '& .MuiSelect-icon': {
            color: 'rgb(107, 114, 128)',
          },
        }}
        MenuProps={{
          PaperProps: {
            sx: {
              backgroundColor: 'white',
              color: 'rgb(17, 24, 39)',
              '& .MuiMenuItem-root': {
                color: 'rgb(17, 24, 39)',
                '&:hover': {
                  backgroundColor: 'rgb(243, 244, 246)',
                },
                '&.Mui-selected': {
                  backgroundColor: 'rgba(59, 130, 246, 0.12)',
                  '&:hover': {
                    backgroundColor: 'rgba(59, 130, 246, 0.18)',
                  },
                },
              },
            },
          },
        }}
      >
        {options.map((option) => (
          <MenuItem key={option.value} value={option.value}>
            {option.label}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};
